module.exports = __webpack_public_path__ + "img/movieTheater-2.026e2c49.jpg";